import { CreateEnquiryRequestDTO } from './DTOs/CreateEnquiryRequestDTO'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'projects/booking/src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class EnquiryService {

    private baseURL = environment.apiBaseUrl

    constructor(
        private http: HttpClient
    ) {}

    submitEnquiry(
        organisationId: string,
        businessId: string,
        venueId: string,
        enquiry: CreateEnquiryRequestDTO
    ): Observable<{ id: string }> {
        const path = `/booking/organisation/${encodeURIComponent(organisationId)}/business/${encodeURIComponent(businessId)}/venue/${encodeURIComponent(venueId)}/enquiry`
        const url = new URL(path, this.baseURL)
        return this.http.post<{ id: string }>(url.toString(), enquiry)
    }
}
